<template>
  <div>
    <h3 class="header-title">
      <img src="../assets/img/iconBack.svg" class="mr-2" @click="GoToClass()"/>Class
    </h3>
    <br />
    <CRow class="mt-1">
      <CCol sm="12">
        <CTabs class="m-2">
          <CTab title="Students" active>
            <CCol sm="12">
              <div>
                <CCard class="custom-explore text-white p-3 m-2">
                  <CRow>
                    <CCol sm="2">SubjectName</CCol>
                    <CCol sm="2">Teacher</CCol>
                    <CCol sm="2">Time</CCol>
                    <CCol sm="4">Attendance</CCol>
                    <CCol sm="2"></CCol>
                  </CRow>
                </CCard>
                <div>
                  <CCol sm="12">
                    <CCard
                      v-for="(item, index) in attendance"
                      v-bind:key="item.Id"
                      class="p-2 custom-box-shadow"
                    >
                      <CRow>
                        <CCol sm="2">
                          <label>
                            <b class="text-custom-primary">{{
                              item.SubjectName
                            }}</b>
                            <br />
                            <b>Grade:</b> {{ item.Grade }} <br />
                            <b>Class:</b> {{ item.Class }}
                          </label>
                        </CCol>
                        <CCol sm="2">
                          {{ item.Teacher }}
                        </CCol>
                        <CCol sm="2">
                          {{ item.Date | moment("DD/MM/YYYY hh:mm A") }}</CCol
                        >
                        <CCol sm="4">
                          Total Student: {{ item.TotalStudentCount }}<br />
                          Present: {{  item.TotalStudentAttendCount }}<br />
                          Absent: {{ item.TotalStudentNoAttendCount }}
                        </CCol>
                        <CCol sm="2">{{ index }} </CCol>
                      </CRow>
          
                    </CCard>
                    <jw-pagination :items="FilteredAttendance" @changePage="onChangePage" :labels="customLabels"></jw-pagination>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CTab>
          <CTab title="Teachers">
            <div>
              <CCard class="custom-explore text-white p-3 m-2">
                <CRow>
                  <CCol sm="2">Subject Name</CCol>
                  <CCol sm="2">Teacher</CCol>
                  <CCol sm="2">Schedule</CCol>
                  <CCol sm="4">Check In/Out</CCol>
                  <CCol sm="2">Is Attend</CCol>
                </CRow>
              </CCard>
              <div>
                <CCol sm="12">
                  <CCard
                    v-for="item in teachers"
                    v-bind:key="item.Id"
                    class="p-2 custom-box-shadow"
                  >
                    <CRow>
                      <CCol sm="2">
                        <label>
                          <b class="text-custom-primary">
                            {{ item.SubjectName }}</b
                          >
                        </label>
                      </CCol>
                      <CCol sm="2">
                        {{ item.Teacher }}
                      </CCol>
                      <CCol sm="2">
                        <td>
                          {{
                            item.ScheduleDateTime | moment("DD/MM/YYYY hh:mm A")
                          }}
                        </td>
                      </CCol>
                      <CCol sm="4">
                        <td>
                          Check In:
                          {{ item.CheckIn | moment("DD/MM/YYYY hh:mm A") }}
                          <br />
                          Check Out:
                          {{ item.CheckOut | moment("DD/MM/YYYY hh:mm A") }}
                        </td>
                      </CCol>
                      <CCol sm="2">
                        <CBadge v-if="item.IsAttend == 'Yes'" color="success"
                          >Yes</CBadge
                        >
                        <CBadge v-else color="danger">No</CBadge>
                      </CCol>
                    </CRow>
                  </CCard>
                  <jw-pagination :items="FilteredAttendanceTeacher" @changePage="onChangePageTeacher" :labels="customLabels"></jw-pagination>
                </CCol>
              </div>
            </div>
          </CTab>
        </CTabs>
      </CCol>
    </CRow>
  </div>
</template>




<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);

const customLabels = {
    first: '<<',
    last: '>>',
    previous: '<',
    next: '>'
};
export default {
  name: "Tables",
  components: {
    PulseLoader,
  },
  data() {
    return {
      customLabels,
      attendance: [],
      teachers: [],
      SearchQuery: "",
      FilteredAttendance: [],
      FilteredAttendanceTeacher: [],
      datacount: {},

      selectedGrade: "ALL GRADE",
      gradeOptions: [],

      selectedClass: "ALL CLASS",
      classOptions: [],

      selectedTeacher: "ALL TEACHER",
      teacherOptions: [],

      Busy: false,

      AttendanceModal: false,
      schedule: [],
      FilteredSchedule: [],
      pageOfItems: []
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetAttendance();
      this.GetAttendanceTeacher();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
},
  methods: {
    onChangePage(attendance) {
            // update page of items
            this.attendance = attendance;
        },
        onChangePageTeacher(teachers) {
            // update page of items
            this.teachers = teachers;
        },
    GetAttendance() {
      this.Busy = true;
      this.$API
        .get(this.$ViewAttendanceStudent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.attendance = response.data;
            this.FilteredAttendance = this.attendance;

            var gradeNames = _.uniq(_.map(response.data, "Grade"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = gradeNames;
            this.gradeOptions.unshift("ALL GRADE");

            var classNames = _.uniq(_.map(response.data, "Class"));
            classNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.classOptions = classNames;
            this.classOptions.unshift("ALL CLASS");

            var teacherNames = _.uniq(_.map(response.data, "Teacher"));
            teacherNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.teacherOptions = teacherNames;
            this.teacherOptions.unshift("ALL TEACHER");
          }
        });
    },
  
    GetAttendanceTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ViewAttendanceTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.teachers = response.data;

            this.FilteredAttendanceTeacher = this.teachers;
          }
        });
    },
    GoToClass()
    {
        this.$router.push("LearningClass")
    }
  },
};
</script>